module.exports = __webpack_public_path__ + "img/photo-veroniquelesourd-accueil-01.b5a5271b.jpeg";